import { useQuery } from "react-query";
import { getSchemaConfiguration, SchemaReq } from "api";
import { useHeaders } from "hooks/api/useHeaders";

export const useSchemaConfiguration = (params: SchemaReq) => {
    const headers = useHeaders();

    return useQuery(["schema", params.admaterial, params.language], () => getSchemaConfiguration(headers, params));
};
